// ─── Утилиты дня рождения ────────────────────────────────────────────────────
// Год-сентинел для ДР «без года» (конвенция Apple Contacts / vCard).
// В БД дата всегда хранится как YYYY-MM-DD; крон поздравлений сравнивает только
// MM-DD, поэтому при незаполненном годе пишется этот фиктивный год.
export const DOB_SENTINEL_YEAR = '1604';

// Возраст, который клиенту исполняется в этом году (число), либо null —
// если год не указан (сентинел) или дата некорректна. Год-агностично к MM-DD:
// «исполняется» = текущий год − год рождения, как в Apple Contacts.
export function birthdayAge(birthday) {
  if (!birthday) return null;
  const [y] = String(birthday).split('-');
  if (!y || y === DOB_SENTINEL_YEAR) return null;
  const year = parseInt(y, 10);
  if (!Number.isFinite(year) || year < 1900) return null;
  const age = new Date().getFullYear() - year;
  if (age < 0 || age > 150) return null;
  return age;
}

// Ширина окна «скоро ДР» (в днях, ±) — единый источник для списка Клиентов
// и карточки Клиента.
export const BD_WINDOW_DAYS = 2;

// true, если ДР клиента попадает в окно ±days от сегодня (по MM-DD,
// с корректным переходом через год). Год рождения игнорируется.
export function isBirthdayNear(birthday, days = BD_WINDOW_DAYS) {
  if (!birthday) return false;
  const [, mm, dd] = String(birthday).split('-');
  if (!mm || !dd) return false;
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const y = now.getFullYear();
  for (const yr of [y - 1, y, y + 1]) {
    const d = new Date(yr, Number(mm) - 1, Number(dd)); d.setHours(0, 0, 0, 0);
    if (Math.abs(Math.round((d - now) / 86400000)) <= days) return true;
  }
  return false;
}

// ─── Статус «поздравлен» — зеркало backend/services/birthdayGreeting.js ─────
// v1 сравнивала голый год — тег не сбрасывался месяцами и рвался на границе
// года. v2 привязывала окно к дате ДР («от ДР до +30 дней») — сломалась на
// реальных данных (инцидент 22.09.2026, Aimtex): поздравили в июне для ДР
// в октябре мимо UI (кнопка видна только в ±2 дня от ДР), и тег «поздравлен»
// провисел с июня по ноябрь. Теперь окно НЕ зависит от даты ДР вообще:
// «поздравлен» = отправка была не позже GREETED_WINDOW_DAYS дней назад.
// greetedYear в сигнатуре оставлен для обратной совместимости вызовов, но на
// результат не влияет — статус решает только greetedAt.
// Дублируется на фронте намеренно: бэк и браузер — разные рантаймы, а логика
// достаточно короткая, чтобы не городить общий пакет ради неё.
export const GREETED_WINDOW_DAYS = 30;

export function isGreetingActive(birthday, greetedYear, greetedAt, now = new Date()) {
  if (!greetedAt) return false;
  const sent = new Date(greetedAt);
  if (isNaN(sent)) return false;
  const deadline = sent.getTime() + GREETED_WINDOW_DAYS * 86400000;
  return now.getTime() <= deadline;
}
